import { Component, Input, OnInit, Signal, signal, ElementRef, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WebsiteStateService } from '../../../../state-management/services/website-state.service';
import { Style } from '../../../../state-management/model/interfaces/state.model';
import { v4 as uuidv4 } from 'uuid';
import { ElementsType, StyleType } from '../../../../state-management/model/enums/state.enums';
import { MatOption, MatSelect } from '@angular/material/select';
import { fadeSlideInOut } from '../../../../animations';

@Component({
  selector: 'app-meta-config',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    MatSelect,
    MatOption
  ],
  templateUrl: './meta-config.component.html',
  styleUrl: './meta-config.component.scss',
  animations: [fadeSlideInOut],
})
export class MetaConfigComponent implements OnInit {
  readonly elemId = input.required<string>();
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input({ required: true }) styleId!: string | null;
  readonly CSDElementRef = input<ElementRef | null>(null);
  readonly eType = input.required<ElementsType>();
  readonly closePanel = output<void>();

  public styles: Signal<Style[]> = signal<Style[]>([]);

  constructor(private stateService: WebsiteStateService) { }

  ngOnInit() {
    if (!this.styleId) {
      this.styleId = uuidv4();
    }
    this.styles = this.stateService.getStylesForID(this.styleId, this.eType());
    this.initializeValues();
  }

  initializeValues() {
    const CSDElementRef = this.CSDElementRef();
    if (CSDElementRef) {
      const element = CSDElementRef.nativeElement;
      const computedStyles = window.getComputedStyle(element);

      this.styles().forEach((style) => {
        const type: StyleType = style.type;
        switch (type) {
          case StyleType.Color:
            style.value = this.convertRGBToHex(computedStyles.color);
            break;
          case StyleType.BackgroundColor:
            style.value = this.convertRGBToHex(computedStyles.backgroundColor);
            break;
          case StyleType.FontSize:
            style.value = this.convertFontToNumber(computedStyles.fontSize);
            break;
          case StyleType.FontWeight:
            style.value = computedStyles.fontWeight;
            break;
          case StyleType.TextAlign:
            style.value = computedStyles.textAlign;
            break;
          default:
            break;
        }
      });
    }
  }

  public updateStyle($event: Event | string, style: Style): void {
    let newValue: string | undefined;
    if ($event instanceof Event) {
      newValue = ($event.target as HTMLInputElement).value;
    } else {
      newValue = $event;
    }
    if (newValue !== undefined && this.styleId) {
      this.stateService.updateStyle(this.elemId(), this.styleId, { ...style, value: newValue });
    }
  }

  public removeStyle(): void {
    if (this.styleId) {
      this.stateService.removeStyle(this.styleId);
    }
  }

  public close() {
    this.closePanel.emit();
  }



  // ### Private helper functions ###
  private convertFontToNumber(font: string): number {
    return parseInt(font.replace('px', ''));
  }

  private convertRGBToHex(rgb: string): string {
    const [r, g, b] = rgb.match(/\d+/g) || ['0', '0', '0'];
    return `#${parseInt(r).toString(16).padStart(2, '0')}${parseInt(g).toString(16).padStart(2, '0')}${parseInt(b).toString(16).padStart(2, '0')}`;
  }
}